import DataIO from "./DataIO";
import Events from "./EventLite";
import {CONFIG} from "../config";

export default class Pumpkins {
	constructor(year = 0, pumpkinData = CONFIG.data, api = CONFIG.api) {
		this.ready = false;
		this.dataUrl = pumpkinData;
		this.api = api;
		this.data = [];
		this.year = year;
		this.voted = localStorage.getItem("vote"+year) != undefined ? true : false;
	} 
	processVotes(data) {
		var oParser = new DOMParser();
		var oDOM = oParser.parseFromString(data, "text/xml");
		var pumpkinData = oDOM.getElementsByTagName("pumpkin");
		var pumpkinVotes = {};
		for(var i = 0; i < pumpkinData.length; i++) {
			var votes = pumpkinData[i].getAttribute("votes");
			if(votes == NaN || votes == undefined || votes == null) {
				votes = "0";
			}
			pumpkinVotes[pumpkinData[i].getAttribute("title")] = votes;
		}
		return pumpkinVotes;
	}
	
	combinePumpkinData(data, votes) {
		for (var i = 0; i < data.pumpkins.length; i++) {
			var vote = votes[data.pumpkins[i].key];
			if(vote == NaN || vote == undefined || vote == null) {
				vote = "0";
			}
			data.pumpkins[i].Votes = parseInt(vote,10);
		}
		return Pumpkins.SortByVotes(data.pumpkins);
	}
	static SortByVotes(data) {
		let changed = false;
		do {
			changed = false;
		for(var i = 0; i < data.length-1; i++) {
			var a = data[i];
			var b = data[i+1];
			if(a.Votes < b.Votes) {
				data[i] = b;
				data[i+1] = a;
				changed = true;
			}
		}
		} while(changed);


		return data;

	}
	vote(pumpkin) {
		if(!this.voted) {
			return DataIO.POST(this.api, {year: this.year, pumpkin: pumpkin}).then(function(data){
				localStorage.setItem("voted", true);
				Events.trigger("voted", data);
				Events.trigger("play", "Vote");
			});
		}
	}
	getPumpkins() {

	}
	get() {
		var pumpkin = this;
		return new Promise(function(resolve, reject){
			Promise.all(
				[DataIO.GET(pumpkin.dataUrl),
				DataIO.GET(pumpkin.api+"?year="+pumpkin.year)]).then(
				function(values) {
					"use strict";
					var pumpkinData = JSON.parse(values[0]);
					var pumpkinVotes = pumpkin.processVotes(values[1]);
					pumpkin.data = pumpkin.combinePumpkinData(pumpkinData, pumpkinVotes);
					pumpkin.ready = true;
					resolve(pumpkin.data);
				}.bind(pumpkin));
			}
		);
	}
}




// WEBPACK FOOTER //
// ./src/Utils/Pumpkins.js